/*
* NOTE: This schema was automatically generated by the build process. Do not update it manually.
*/

import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * The `Date` scalar type represents a date. The Date appears in a JSON
   * response as an ISO8601 formatted string.
   */
  Date: { input: string; output: Date; }
  /**
   * The `DateTime` scalar type represents a date and time in the UTC
   * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
   * string, including UTC timezone ("Z"). The parsed date and time string will
   * be converted to UTC and any UTC offset other than 0 will be rejected.
   */
  DateTime: { input: Date; output: Date; }
  /** Represents HTML rendered content. Transported as a String. E.g.: "<b>Hello</b> world". */
  HTML: { input: string; output: string; }
};

/** A report for a 401(k) plan or other workplace benefit */
export type BenefitReport = ReportInterface & {
  __typename: 'BenefitReport';
  /** The format of the report file (PDF, CSV, or ZIP) */
  contentType: BenefitReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The employer associated with the report */
  employer: Employer;
  /** The end date of the reporting period */
  endDate?: Maybe<Scalars['DateTime']['output']>;
  /** The unique identifier for the report */
  id: Scalars['ID']['output'];
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The start date of the reporting period */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the report (PENDING or COMPLETE) */
  status: BenefitReportStatus;
};

/** The content type of a 401(k) report file */
export enum BenefitReportContentType {
  /** A csv file */
  Csv = 'CSV',
  /** A PDF file */
  Pdf = 'PDF',
  /** A ZIP file */
  Zip = 'ZIP'
}

/** Options available for creating a 401(k) plan or other B@W benefit report */
export type BenefitReportCreationOption = {
  __typename: 'BenefitReportCreationOption';
  /** An additional explanatory blurb to help the user interpret the report. Supports a subset of html */
  additionalGuidance?: Maybe<Scalars['HTML']['output']>;
  /** An identifier referencing a specific report that can be used as a path param */
  altIdentifier?: Maybe<Scalars['String']['output']>;
  /** The columns included in the report */
  columns: Array<Scalars['String']['output']>;
  /** The description of the report */
  description: Scalars['String']['output'];
  /** A unique identifier for the report creation option */
  id: Scalars['ID']['output'];
  /** The inputs required to create the report */
  inputs: Array<BenefitReportInputOption>;
  /** Whether the report is commonly run */
  isCommon: Scalars['Boolean']['output'];
  /** The name of the report creation option */
  name: Scalars['String']['output'];
  /** The type of the report creation option */
  type: Scalars['String']['output'];
};

/** Input options for creating a 401(k) plan report */
export type BenefitReportInputOption = {
  __typename: 'BenefitReportInputOption';
  /** The attribute name of the input option */
  attribute: Scalars['String']['output'];
  /** The default value of the input. Represented as a string, for easy integration with form inputs */
  default?: Maybe<Scalars['String']['output']>;
  /** The label of the input option */
  label: Scalars['String']['output'];
  /** The type of the input option */
  type: BenefitReportInputOptionType;
};

/** The type of input data we're expecting from the user user to run a report */
export enum BenefitReportInputOptionType {
  /** A JSON boolean (true/false) */
  Boolean = 'BOOLEAN',
  /** A iso8601 date string (ie 2025-01-01) */
  Date = 'DATE',
  /** A four digit year string (ie 2023) */
  Year = 'YEAR'
}

/** The status of a 401(k) report */
export enum BenefitReportStatus {
  /** Complete */
  Complete = 'COMPLETE',
  /** Pending */
  Pending = 'PENDING'
}

/** Autogenerated input type of CapturePackageSignatureMutation */
export type CapturePackageSignatureMutationInput = {
  /** The ID of the record tracking the signable package. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of CapturePackageSignatureMutation. */
export type CapturePackageSignatureMutationPayload = {
  __typename: 'CapturePackageSignatureMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CapturePackageSignatureMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CapturePackageSignatureMutation execution as type SignablePackage. */
  result?: Maybe<SignablePackage>;
};

/**
 * Input structure for an argument for a benefit report, not every field applies to
 * every report, which is way they're all not required. We rely on runtime
 * validation to ensure the right inputs are provided
 */
export type CreateBenefitReportInput = {
  /** Filters to the only active participants, only applies to the deferral history report */
  activeParticipantsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** End date for data filtering for reports that are time limited */
  endDate?: InputMaybe<Scalars['Date']['input']>;
  /** Filters to the latest records, only applies to the deferral history report */
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to show the full ssn on reports that include it */
  showSsn?: InputMaybe<Scalars['Boolean']['input']>;
  /** Start date for data filtering for reports for report that are time limited */
  startDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Autogenerated input type of CreateBenefitReportMutation */
export type CreateBenefitReportMutationInput = {
  /** The id of the employer this report is for */
  employerId: Scalars['ID']['input'];
  /** The user provided inputs into report generation */
  reportInput: CreateBenefitReportInput;
  /** The type/name of the report to generate */
  type: Scalars['String']['input'];
};

/** Autogenerated return type of CreateBenefitReportMutation. */
export type CreateBenefitReportMutationPayload = {
  __typename: 'CreateBenefitReportMutationPayload';
  /** The user-displayable errors produced while attempting to resolve CreateBenefitReportMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the CreateBenefitReportMutation execution as type BenefitReport. */
  result?: Maybe<BenefitReport>;
};

/** A zip file containing reports specific to a 401(k) plan deconversion */
export type DeconversionReport = ReportInterface & {
  __typename: 'DeconversionReport';
  /** The format of the report file (PDF, CSV, or ZIP) */
  contentType: BenefitReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The employer associated with the report */
  employer: Employer;
  /** The unique identifier for the report */
  id: Scalars['ID']['output'];
  /** Date on which funds will be sent from Betterment to the new 401(k) provider */
  liquidationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The current status of the report (PENDING or COMPLETE) */
  status: BenefitReportStatus;
};

/** A recoverable error that can be displaying to the User. */
export type DisplayableError = {
  __typename: 'DisplayableError';
  /** A human-readable error message to display to the user explaining the error and remediating actions. */
  message: Scalars['String']['output'];
  /** The path, the Operation entity or Input value that is the source of the error. */
  path: Array<Scalars['String']['output']>;
};

/** DocuSign-related attributes required for signing the DocuSign envelope in-app. */
export type DocusignSignature = {
  __typename: 'DocusignSignature';
  /** The DocuSign Client ID */
  clientId: Scalars['String']['output'];
  /** The DocuSign signature URL */
  signatureUrl: Scalars['String']['output'];
};

/** An email preference setting for the plan manager for a given customer */
export type EmailPreference = {
  __typename: 'EmailPreference';
  /** The category of emails controlled by this preference */
  category: EmailPreferenceCategory;
  /** The enum value for the email preference */
  id: Scalars['ID']['output'];
  /** Whether or not the plan sponsor has opted into receiving this category of notification */
  isEnabled: Scalars['Boolean']['output'];
  /** Human readable description of the kinds of notifications controlled by this preference */
  label: Scalars['String']['output'];
};

/** A discrete notification preference the plan sponsor can enable or disable, which controls some subset of the emails they get */
export enum EmailPreferenceCategory {
  /** Controls whether the plan sponsor gets emails when participants change their deferral settings */
  ReceiveDeferralSettingChangeEmails = 'RECEIVE_DEFERRAL_SETTING_CHANGE_EMAILS',
  /** Controls whether the plan sponsor receives emails when participants request loans and distributions */
  ReceiveDistributionAndLoanEmails = 'RECEIVE_DISTRIBUTION_AND_LOAN_EMAILS',
  /** Controls whether the plan sponsor gets emails when new payrolls are created */
  ReceivePayrollEmails = 'RECEIVE_PAYROLL_EMAILS',
  /** Controls whether the plan sponsor receives misc emails about general 401k plan administration */
  ReceivePlanAdministrationEmails = 'RECEIVE_PLAN_ADMINISTRATION_EMAILS'
}

/** Represents an organization that has an account in the B@W system */
export type Employer = {
  __typename: 'Employer';
  /**
   * A list of what kinds of notifications and emails the plan manager can receive
   * for a given customer, and which ones the plan manager has opted into
   */
  emailPreferences: Array<EmailPreference>;
  /** The unique identifier to the employer */
  id: Scalars['ID']['output'];
  /** A list of possible reports that current user can run for this employer */
  reportCreationOptions: Array<BenefitReportCreationOption>;
  /** A list of reports the employer has access to */
  reports: Array<BenefitReport | DeconversionReport>;
};

/** Autogenerated input type of ForwardPackageSignatureMutation */
export type ForwardPackageSignatureMutationInput = {
  /** The new signer's full name. */
  email: Scalars['String']['input'];
  /** The new signer's email address. */
  name: Scalars['String']['input'];
  /** The ID of the record tracking the signable package. */
  signablePackageId: Scalars['ID']['input'];
};

/** Autogenerated return type of ForwardPackageSignatureMutation. */
export type ForwardPackageSignatureMutationPayload = {
  __typename: 'ForwardPackageSignatureMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ForwardPackageSignatureMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ForwardPackageSignatureMutation execution as type SignablePackage. */
  result?: Maybe<SignablePackage>;
};

/** The entrypoint for all b4b schema mutations */
export type Mutation = {
  __typename: 'Mutation';
  /** Capture signature of a signable package. */
  capturePackageSignature: CapturePackageSignatureMutationPayload;
  /** Asynchronously generates a new report based on the provided inputs */
  createBenefitReport: CreateBenefitReportMutationPayload;
  /** Forward signature of a signable package. */
  forwardPackageSignature: ForwardPackageSignatureMutationPayload;
  /** Reclaim a package that was forwarded to an external recipient for in-app signing. */
  reclaimPackageSignature: ReclaimPackageSignatureMutationPayload;
};


/** The entrypoint for all b4b schema mutations */
export type MutationCapturePackageSignatureArgs = {
  input: CapturePackageSignatureMutationInput;
};


/** The entrypoint for all b4b schema mutations */
export type MutationCreateBenefitReportArgs = {
  input: CreateBenefitReportMutationInput;
};


/** The entrypoint for all b4b schema mutations */
export type MutationForwardPackageSignatureArgs = {
  input: ForwardPackageSignatureMutationInput;
};


/** The entrypoint for all b4b schema mutations */
export type MutationReclaimPackageSignatureArgs = {
  input: ReclaimPackageSignatureMutationInput;
};

/** Represents the personal information of a plan manager */
export type PersonalProfile = {
  __typename: 'PersonalProfile';
  /** The email address of the plan manager */
  email: Scalars['String']['output'];
  /** The first name of the plan manager */
  firstName: Scalars['String']['output'];
  /** The job title of the plan manager */
  jobTitle: Scalars['String']['output'];
  /** The last name of the plan manager */
  lastName: Scalars['String']['output'];
  /** The middle initial of the plan manager */
  middleInitial?: Maybe<Scalars['String']['output']>;
  /** The work phone number of the plan manager; e.g. (480)-222-3344 */
  workPhoneNumber: Scalars['String']['output'];
};

/** The entrypoint for all b4b schema queries */
export type Query = {
  __typename: 'Query';
  /** The details for a single employer by id */
  employer: Employer;
  /** The list of all employers the plan manager has access to */
  employers: Array<Employer>;
  /** The personal profile of the current plan manager */
  personalProfile: PersonalProfile;
  /** The details for a signable package by id */
  signablePackage: SignablePackage;
};


/** The entrypoint for all b4b schema queries */
export type QueryEmployerArgs = {
  id: Scalars['ID']['input'];
};


/** The entrypoint for all b4b schema queries */
export type QuerySignablePackageArgs = {
  id: Scalars['ID']['input'];
};

/** Autogenerated input type of ReclaimPackageSignatureMutation */
export type ReclaimPackageSignatureMutationInput = {
  /** The ID of the signable package. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ReclaimPackageSignatureMutation. */
export type ReclaimPackageSignatureMutationPayload = {
  __typename: 'ReclaimPackageSignatureMutationPayload';
  /** The user-displayable errors produced while attempting to resolve ReclaimPackageSignatureMutation. */
  displayableErrors: Array<DisplayableError>;
  /** The successful result from the ReclaimPackageSignatureMutation execution as type SignablePackage. */
  result?: Maybe<SignablePackage>;
};

/** Shared fields for benefit and deconversion reports */
export type ReportInterface = {
  /** The format of the report file (PDF, CSV, or ZIP) */
  contentType: BenefitReportContentType;
  /** The timestamp when the report was created */
  createdAt: Scalars['DateTime']['output'];
  /** The employer associated with the report */
  employer: Employer;
  /** The unique identifier for the report */
  id: Scalars['ID']['output'];
  /** The name of the report */
  name: Scalars['String']['output'];
  /** The current status of the report (PENDING or COMPLETE) */
  status: BenefitReportStatus;
};

/** A list of documents that can be signed in-app via Docusign */
export type SignablePackage = {
  __typename: 'SignablePackage';
  /** DocuSign-related attributes required for signing the package. */
  docusignSignature?: Maybe<DocusignSignature>;
  /** The email address of the user whom the envelope was forwarded to for remote signing. */
  forwardedToEmail?: Maybe<Scalars['String']['output']>;
  /** The ID of the signable package. */
  id: Scalars['ID']['output'];
  /** The signature status of the signable package. */
  signed: Scalars['Boolean']['output'];
  /** The type of the signable package. */
  type: Scalars['String']['output'];
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;


/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  ReportInterface: ( Omit<BenefitReport, 'employer'> & { employer: _RefType['Employer'] } ) | ( Omit<DeconversionReport, 'employer'> & { employer: _RefType['Employer'] } );
};

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  BenefitReport: ResolverTypeWrapper<Omit<BenefitReport, 'employer'> & { employer: ResolversTypes['Employer'] }>;
  BenefitReportContentType: BenefitReportContentType;
  BenefitReportCreationOption: ResolverTypeWrapper<BenefitReportCreationOption>;
  BenefitReportInputOption: ResolverTypeWrapper<BenefitReportInputOption>;
  BenefitReportInputOptionType: BenefitReportInputOptionType;
  BenefitReportStatus: BenefitReportStatus;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CapturePackageSignatureMutationInput: CapturePackageSignatureMutationInput;
  CapturePackageSignatureMutationPayload: ResolverTypeWrapper<CapturePackageSignatureMutationPayload>;
  CreateBenefitReportInput: CreateBenefitReportInput;
  CreateBenefitReportMutationInput: CreateBenefitReportMutationInput;
  CreateBenefitReportMutationPayload: ResolverTypeWrapper<Omit<CreateBenefitReportMutationPayload, 'result'> & { result?: Maybe<ResolversTypes['BenefitReport']> }>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DeconversionReport: ResolverTypeWrapper<Omit<DeconversionReport, 'employer'> & { employer: ResolversTypes['Employer'] }>;
  DisplayableError: ResolverTypeWrapper<DisplayableError>;
  DocusignSignature: ResolverTypeWrapper<DocusignSignature>;
  EmailPreference: ResolverTypeWrapper<EmailPreference>;
  EmailPreferenceCategory: EmailPreferenceCategory;
  Employer: ResolverTypeWrapper<Omit<Employer, 'emailPreferences' | 'reports'> & { emailPreferences: Array<ResolversTypes['EmailPreference']>, reports: Array<ResolversTypes['ReportInterface']> }>;
  ForwardPackageSignatureMutationInput: ForwardPackageSignatureMutationInput;
  ForwardPackageSignatureMutationPayload: ResolverTypeWrapper<ForwardPackageSignatureMutationPayload>;
  HTML: ResolverTypeWrapper<Scalars['HTML']['output']>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Mutation: ResolverTypeWrapper<{}>;
  PersonalProfile: ResolverTypeWrapper<PersonalProfile>;
  Query: ResolverTypeWrapper<{}>;
  ReclaimPackageSignatureMutationInput: ReclaimPackageSignatureMutationInput;
  ReclaimPackageSignatureMutationPayload: ResolverTypeWrapper<ReclaimPackageSignatureMutationPayload>;
  ReportInterface: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['ReportInterface']>;
  SignablePackage: ResolverTypeWrapper<SignablePackage>;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  BenefitReport: Omit<BenefitReport, 'employer'> & { employer: ResolversParentTypes['Employer'] };
  BenefitReportCreationOption: BenefitReportCreationOption;
  BenefitReportInputOption: BenefitReportInputOption;
  Boolean: Scalars['Boolean']['output'];
  CapturePackageSignatureMutationInput: CapturePackageSignatureMutationInput;
  CapturePackageSignatureMutationPayload: CapturePackageSignatureMutationPayload;
  CreateBenefitReportInput: CreateBenefitReportInput;
  CreateBenefitReportMutationInput: CreateBenefitReportMutationInput;
  CreateBenefitReportMutationPayload: Omit<CreateBenefitReportMutationPayload, 'result'> & { result?: Maybe<ResolversParentTypes['BenefitReport']> };
  Date: Scalars['Date']['output'];
  DateTime: Scalars['DateTime']['output'];
  DeconversionReport: Omit<DeconversionReport, 'employer'> & { employer: ResolversParentTypes['Employer'] };
  DisplayableError: DisplayableError;
  DocusignSignature: DocusignSignature;
  EmailPreference: EmailPreference;
  Employer: Omit<Employer, 'emailPreferences' | 'reports'> & { emailPreferences: Array<ResolversParentTypes['EmailPreference']>, reports: Array<ResolversParentTypes['ReportInterface']> };
  ForwardPackageSignatureMutationInput: ForwardPackageSignatureMutationInput;
  ForwardPackageSignatureMutationPayload: ForwardPackageSignatureMutationPayload;
  HTML: Scalars['HTML']['output'];
  ID: Scalars['ID']['output'];
  Mutation: {};
  PersonalProfile: PersonalProfile;
  Query: {};
  ReclaimPackageSignatureMutationInput: ReclaimPackageSignatureMutationInput;
  ReclaimPackageSignatureMutationPayload: ReclaimPackageSignatureMutationPayload;
  ReportInterface: ResolversInterfaceTypes<ResolversParentTypes>['ReportInterface'];
  SignablePackage: SignablePackage;
  String: Scalars['String']['output'];
};

export type OwnedDirectiveArgs = {
  by: Scalars['String']['input'];
};

export type OwnedDirectiveResolver<Result, Parent, ContextType = any, Args = OwnedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type BenefitReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitReport'] = ResolversParentTypes['BenefitReport']> = {
  contentType?: Resolver<ResolversTypes['BenefitReportContentType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  endDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  startDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitReportStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitReportCreationOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitReportCreationOption'] = ResolversParentTypes['BenefitReportCreationOption']> = {
  additionalGuidance?: Resolver<Maybe<ResolversTypes['HTML']>, ParentType, ContextType>;
  altIdentifier?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  columns?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  inputs?: Resolver<Array<ResolversTypes['BenefitReportInputOption']>, ParentType, ContextType>;
  isCommon?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type BenefitReportInputOptionResolvers<ContextType = any, ParentType extends ResolversParentTypes['BenefitReportInputOption'] = ResolversParentTypes['BenefitReportInputOption']> = {
  attribute?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  default?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['BenefitReportInputOptionType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CapturePackageSignatureMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CapturePackageSignatureMutationPayload'] = ResolversParentTypes['CapturePackageSignatureMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type CreateBenefitReportMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['CreateBenefitReportMutationPayload'] = ResolversParentTypes['CreateBenefitReportMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['BenefitReport']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Date'], any> {
  name: 'Date';
}

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DeconversionReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeconversionReport'] = ResolversParentTypes['DeconversionReport']> = {
  contentType?: Resolver<ResolversTypes['BenefitReportContentType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  liquidationDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitReportStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DisplayableErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['DisplayableError'] = ResolversParentTypes['DisplayableError']> = {
  message?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  path?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DocusignSignatureResolvers<ContextType = any, ParentType extends ResolversParentTypes['DocusignSignature'] = ResolversParentTypes['DocusignSignature']> = {
  clientId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  signatureUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmailPreferenceResolvers<ContextType = any, ParentType extends ResolversParentTypes['EmailPreference'] = ResolversParentTypes['EmailPreference']> = {
  category?: Resolver<ResolversTypes['EmailPreferenceCategory'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  isEnabled?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type EmployerResolvers<ContextType = any, ParentType extends ResolversParentTypes['Employer'] = ResolversParentTypes['Employer']> = {
  emailPreferences?: Resolver<Array<ResolversTypes['EmailPreference']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  reportCreationOptions?: Resolver<Array<ResolversTypes['BenefitReportCreationOption']>, ParentType, ContextType>;
  reports?: Resolver<Array<ResolversTypes['ReportInterface']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ForwardPackageSignatureMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ForwardPackageSignatureMutationPayload'] = ResolversParentTypes['ForwardPackageSignatureMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface HtmlScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['HTML'], any> {
  name: 'HTML';
}

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  capturePackageSignature?: Resolver<ResolversTypes['CapturePackageSignatureMutationPayload'], ParentType, ContextType, RequireFields<MutationCapturePackageSignatureArgs, 'input'>>;
  createBenefitReport?: Resolver<ResolversTypes['CreateBenefitReportMutationPayload'], ParentType, ContextType, RequireFields<MutationCreateBenefitReportArgs, 'input'>>;
  forwardPackageSignature?: Resolver<ResolversTypes['ForwardPackageSignatureMutationPayload'], ParentType, ContextType, RequireFields<MutationForwardPackageSignatureArgs, 'input'>>;
  reclaimPackageSignature?: Resolver<ResolversTypes['ReclaimPackageSignatureMutationPayload'], ParentType, ContextType, RequireFields<MutationReclaimPackageSignatureArgs, 'input'>>;
};

export type PersonalProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['PersonalProfile'] = ResolversParentTypes['PersonalProfile']> = {
  email?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  jobTitle?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  middleInitial?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  workPhoneNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType, RequireFields<QueryEmployerArgs, 'id'>>;
  employers?: Resolver<Array<ResolversTypes['Employer']>, ParentType, ContextType>;
  personalProfile?: Resolver<ResolversTypes['PersonalProfile'], ParentType, ContextType>;
  signablePackage?: Resolver<ResolversTypes['SignablePackage'], ParentType, ContextType, RequireFields<QuerySignablePackageArgs, 'id'>>;
};

export type ReclaimPackageSignatureMutationPayloadResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReclaimPackageSignatureMutationPayload'] = ResolversParentTypes['ReclaimPackageSignatureMutationPayload']> = {
  displayableErrors?: Resolver<Array<ResolversTypes['DisplayableError']>, ParentType, ContextType>;
  result?: Resolver<Maybe<ResolversTypes['SignablePackage']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportInterfaceResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReportInterface'] = ResolversParentTypes['ReportInterface']> = {
  __resolveType: TypeResolveFn<'BenefitReport' | 'DeconversionReport', ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['BenefitReportContentType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  employer?: Resolver<ResolversTypes['Employer'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['BenefitReportStatus'], ParentType, ContextType>;
};

export type SignablePackageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignablePackage'] = ResolversParentTypes['SignablePackage']> = {
  docusignSignature?: Resolver<Maybe<ResolversTypes['DocusignSignature']>, ParentType, ContextType>;
  forwardedToEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  signed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  BenefitReport?: BenefitReportResolvers<ContextType>;
  BenefitReportCreationOption?: BenefitReportCreationOptionResolvers<ContextType>;
  BenefitReportInputOption?: BenefitReportInputOptionResolvers<ContextType>;
  CapturePackageSignatureMutationPayload?: CapturePackageSignatureMutationPayloadResolvers<ContextType>;
  CreateBenefitReportMutationPayload?: CreateBenefitReportMutationPayloadResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DateTime?: GraphQLScalarType;
  DeconversionReport?: DeconversionReportResolvers<ContextType>;
  DisplayableError?: DisplayableErrorResolvers<ContextType>;
  DocusignSignature?: DocusignSignatureResolvers<ContextType>;
  EmailPreference?: EmailPreferenceResolvers<ContextType>;
  Employer?: EmployerResolvers<ContextType>;
  ForwardPackageSignatureMutationPayload?: ForwardPackageSignatureMutationPayloadResolvers<ContextType>;
  HTML?: GraphQLScalarType;
  Mutation?: MutationResolvers<ContextType>;
  PersonalProfile?: PersonalProfileResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  ReclaimPackageSignatureMutationPayload?: ReclaimPackageSignatureMutationPayloadResolvers<ContextType>;
  ReportInterface?: ReportInterfaceResolvers<ContextType>;
  SignablePackage?: SignablePackageResolvers<ContextType>;
};

export type DirectiveResolvers<ContextType = any> = {
  owned?: OwnedDirectiveResolver<any, any, ContextType>;
};
